module.exports = __webpack_public_path__ + "static/img/ls41.3f233dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls41.png
// module id = QoaW
// module chunks = 12